import React, { useEffect, useState } from 'react';
import female from '../assets/female.png';
import male from '../assets/male.png';

interface ItemData {
  id: number;
  name: string;
  content: string;
  image: string;
}

const reviews: ItemData[] = [
  {
    id: 1,
    name: 'Chioma Emeka',
    content: `It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. `,
    image: female
  },
  {
    id: 2,
    name: 'Abdul Tanko',
    content: `It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. `,
    image: male
  },
  {
    id: 3,
    name: 'John Jones',
    content: `It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. `,
    image: male
  },
  {
    id: 4,
    name: 'Sonia Aliyu',
    content: `It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially.`,
    image: male
  },
  {
    id: 5,
    name: 'Tunde Stash',
    content: 'I just love how easy it is to get a will',
    image: male
  },
  {
    id: 6,
    name: 'Gold Rose',
    content: `It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. `,
    image: male
  }
  // Add more cards as needed
];

const IWillReview: React.FC = () => {
  const [, setScrollY] = useState(0);

  useEffect(() => {
    const scrollContainer = document.querySelector('.card-list');

    if (scrollContainer) {
      const scrollHeight =
        scrollContainer.scrollHeight - scrollContainer.clientHeight;
      let currentScroll = 0;

      const scrollInterval = setInterval(() => {
        currentScroll += 300; // Adjust the scroll speed by changing this value
        if (currentScroll > scrollHeight) {
          currentScroll = 0;
        }
        scrollContainer.scrollTop = currentScroll;
        setScrollY(currentScroll);
      }, 2000); // Adjust the interval for smoother/faster scrolling

      return () => {
        clearInterval(scrollInterval);
      };
    }
  }, []);

  return (
    <div className="relative h-[484px] w-[35%] max-w-md overflow-hidden opacity-80">
      <div className="card-list h-full overflow-y-scroll scroll-smooth pb-10 scrollbar-hide">
        {reviews.map(review => (
          <div key={review.id} className="p-2">
            <div className="flex rounded-lg bg-white p-4 shadow-md">
              <div className="shrink-0">
                <img
                  className="h-14 w-14 rounded-full"
                  src={review.image}
                  alt={review.name}
                />
              </div>
              <div className="ml-4">
                <h2 className="mb-2 text-base font-bold tracking-tight text-[#121638]">
                  {review.name}
                </h2>
                <p className="mb-3 font-normal text-[#121638]">
                  {review.content}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IWillReview;
